import { apiClient } from './apiClient';

export interface BackendVersionInfo {
  api: string;
  bl: string;
  dl: string;
  sepa: string;
  gitSha?: string;
  buildDate?: string;
  environment: string;
  serverTime: string;
}

export const versionService = {
  async getVersionInfo(): Promise<BackendVersionInfo | null> {
    try {
      const response = await apiClient.get<BackendVersionInfo>('/version');
      return response.data;
    } catch {
      return null;
    }
  }
};
